import { Component, OnInit } from '@angular/core';
import { CommonService } from 'app/service/common.service';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {

  constructor(public commonService: CommonService) { }

  ngOnInit() {
    if(this.commonService.pages)
      this.commonService.pages.accedi = null;
  }

}
